module.exports = __webpack_public_path__ + "img/stonesize-1@2x.2e67fbf.png";